<template>
    <b-button class="del-btn-cover"
              variant="outline-secondary"
              @click="$emit('btnClick')">
        <i class="fa-solid fa-minus del-icon"></i>
    </b-button>
</template>

<script>
export default {
    name: "MinusBtn"
}
</script>

<style scoped>
.del-btn-cover:hover {
    background-color: transparent;
    color: #212529;
    padding: .25rem .1rem
}

.del-btn-cover:hover .del-icon {
    display: block !important;
}

.del-icon {
    display: none !important;
}
</style>
